import React, {useState, useEffect} from 'react'
import Layout from '../../components/Layouts/Layout'
import AdminMenu from '../../components/Layouts/AdminMenu'
import  toast  from 'react-hot-toast';
import axios from 'axios';
import {Select} from "antd";
import { useNavigate } from 'react-router-dom';
const {Option} = Select

const CreateProduct = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [category, setCategory] = useState("");
  const [quantity, setQuantity] = useState("");
  const [shipping, setShipping] = useState("");
  const [photo, setPhoto] = useState("");

  // get all category
  const getAllCategory = async() => {
    try{
      const {data} = await axios.get(`/api/v1/category/all-category`);
      if(data?.success){
        setCategories(data?.category);
      }
    }catch(error){
      // console.log(error);
      toast.error("Something went wrongin getting category");
    }
  };

  // handle create Product

  const handleCreate = async(e) => {
    e.preventDefault();
    try{
      const productData = new FormData()
      productData.append("name", name);
      productData.append("description", description);
      productData.append("price", price);
      productData.append("quantity", quantity);
      productData.append("photo", photo);
      productData.append("category", category);
      const {data} = axios.post(`/api/v1/product/create-product`, productData);
      if(data?.success){
        toast.error(data?.message);
      }else{
        toast.success('Product Created Successfully');
        navigate('/dashboard/admin/products');
      }

    }catch(error){
      // console.log(error);
      toast.error('something went wrong');
    }
  };

  useEffect(() => {
    getAllCategory();
  }, []);

  return (
    <Layout title={"Dashboard- create category"}>
        <div className='container-fluid m-3 p-3'></div>
        <div className='row'>
            <div className='col-md-3'>
                <AdminMenu />
            </div>
            <div className='col-md-9'>
                <h1>Create Product</h1>
                <div className='m-1'>
                  <Select 
                    bordered= {false}
                    placeholder= "Select a category"
                    size='large'
                    showSearch
                    className='form-select mb-3'
                    onChange={(value) => setCategory(value)}
                  >
                    {categories?.map(c => (
                      <Option key={c._id} value={c._id}>{c.name}</Option>
                    ))}
                  </Select>
                  <div className='mb-3'>
                    <label className='btn btn-outline-secondary col-md-12'>
                      {photo ? photo.name : "Upload Photo"}
                      <input 
                        type='file'
                        name='photo'
                        accept='image/*'
                        onChange={(e) => setPhoto(e.target.files[0])}
                        hidden
                      />
                    </label>
                  </div>
                  <div className='mb-3'>
                    {photo && (
                      <div className='text-center'>
                        <img 
                          src={URL.createObjectURL(photo)}
                          alt='product'
                          height={'200px'}
                          className='img img-responsive'
                        />
                      </div>
                    )}
                  </div>
                  <div className='mb-3'>
                    <input 
                      type='text'
                      value={name}
                      placeholder='write a name'
                      className='form-control'
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                  <div className='mb-3'>
                    <textarea 
                      rows="4"
                      cols="25"
                      value={description}
                      placeholder='write a description'
                      className='form-control'
                      onChange={(e) => setDescription(e.target.value)}
                    ></textarea>
                  </div>
                  <div className='mb-3'>
                    <input 
                      type='number'
                      value={price}
                      placeholder='write a Price'
                      className='form-control'
                      onChange={(e) => setPrice(e.target.value)}
                    />
                  </div>
                  <div className='mb-3'>
                    <input 
                      type='number'
                      min="0"
                      max="100"
                      value={quantity}
                      placeholder='write a quantity'
                      className='form-control'
                      onChange={(e) => setQuantity(e.target.value)}
                    />
                  </div>
                  <div className='mb-3'>
                    <select 
                      value={shipping}
                      className='form-control'
                      placeholder='Select Shipping'
                      size="large"
                      showSearch
                      onChange={(e) => setShipping(e.target.value)}
                    >
                      <option value="">Select Shipping</option>
                      <option value="1">Yes</option>
                      <option value="0">No</option>
                    </ select>
                  </div>
                    <div className='mb-3'>
                      <button className='btn btn-primary' onClick={handleCreate}>CREATE PRODUCT</button>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
  )
}

export default CreateProduct